'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = require('../../env/env');

exports.default = function () {
  return (0, _env.getEnvData)('CARDS_API_KEY');
};